import { PositionsColumns } from '@/modules/trade/services/instruments/enums';

export const positionsOptionsV2 = [
  { label: 'Saldo total', value: PositionsColumns.balance },
  { label: 'Preço do dia', value: PositionsColumns.lastPrice },
  { label: 'Quantidade', value: PositionsColumns.quantity },
  { label: 'Preço médio', value: PositionsColumns.averagePrice }
];
